import React from 'react'
import { Link } from 'react-router'
import { Grid, Row, Col } from 'react-bootstrap'
import i18next from 'i18next'

import adminStyles from './styles/admin.scss'

class SubNavigation extends React.Component {
  render() {
    return (
      <div>
        <div className={adminStyles.subNavigation}>
          <div className={adminStyles.container}>
            <Grid>
              <Row>
                <Col md={12}>{this.props.menu}</Col>
              </Row>
            </Grid>
          </div>
        </div>

        {this.props.children &&
          React.cloneElement(this.props.children, {
            currentOrganisationId: this.props.currentOrganisationId
          })}
      </div>
    )
  }
}

const MainSubNavigation = props => {
  const menu = (
    <div className="sub-navigation">
      <Link to="/">{i18next.t('questionnaires')}</Link>
      <Link to="/group-roles">{i18next.t('group_roles')}</Link>
      <Link to="/group-drivers">{i18next.t('group_drivers')}</Link>
      <Link to="/wopi360">{i18next.t('wopi360')}</Link>
      <Link to="/units">{i18next.t('units')}</Link>
    </div>
  )

  return (
    <SubNavigation menu={menu} {...props}>
      {props.children}
    </SubNavigation>
  )
}

const OrganisationAdminSubNavigation = props => {
  const menu = (
    <div>
      <Link to="/management">{i18next.t('accounts')}</Link>
      <Link to="/management/log">{i18next.t('usage_log')}</Link>
      <Link to="/management/data">{i18next.t('organisation_data')}</Link>
    </div>
  )

  return (
    <SubNavigation menu={menu} {...props}>
      {props.children}
    </SubNavigation>
  )
}

const SuperAdminSubNavigation = props => {
  const menu = (
    <div>
      <Link to="/admin/accounts">{i18next.t('accounts')}</Link>
      <Link to="/admin/organisations">{i18next.t('customer_organisations')}</Link>
      <Link to="/admin/invoicing">{i18next.t('invoicing')}</Link>
      <Link to="/admin/translations">{i18next.t('translations')}</Link>
    </div>
  )

  return (
    <SubNavigation menu={menu} {...props}>
      {props.children}
    </SubNavigation>
  )
}

export { MainSubNavigation, OrganisationAdminSubNavigation, SuperAdminSubNavigation }



// WEBPACK FOOTER //
// ./src/components/SubNavigation.js